<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog-large">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Question Report</h4>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-md-3">From:<input type="input" [(ngModel)]="fromATOS" id="fromValue"></div>
                    <div class="col-md-3">To:<input type="input" [(ngModel)]="toATOS"  id="toValue"></div>
                    <div class="col-md-2"><button type="button" class="btn btn-success" (click)="filterATOS()">Filter</button></div>
                    <div class="col-md-2"><button class="btn btn-danger" (click)="clearFilter()">Clear</button></div>
                </div>

                <div style="max-height: 400px; overflow: auto;">
                    <table class="table">
                        <thead class="thead-inverse">
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                lexile
                            </th>
                            <th>
                                atos
                            </th>
                            <th>
                                fandp
                            </th>
                            <th>
                                sentence
                            </th>
                            <th>
                                type
                            </th>
                            <th>
                                presentation
                            </th>
                            <th>
                                thinking
                            </th>
                            <th>
                                skill
                            </th>
                        </tr>
                        </thead>
                        <tr *ngFor="let question of questions">
                            <td>{{ question.selectionName }}</td>
                            <td>{{ question.lexile}}</td>
                            <td>{{ question.atos}}</td>
                            <td>{{ question.fandp}}</td>
                            <td>{{ question.sentence}}</td>
                            <td>{{ question.type}}</td>
                            <td>{{ question.presentation}}</td>
                            <td>{{ question.thinking}}</td>
                            <td>{{ question.skill}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
